import { Box, LinearProgress } from "@mui/material";
import { PowerBIEmbed } from "powerbi-client-react";
import { models, Report } from "powerbi-client";
import React, { useEffect, useState } from "react";
import { getPowerBIContent } from "../../services/fetch";
import "./PowerBIReport.css";
import { EmbedParams } from "../../services/types";
import { useConfig } from "../../context/ConfigContext";

const PowerBiReport = () => {
	const { user } = useConfig();
	const [reportData, setReportData] = useState<EmbedParams>(null);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const getReportData = async () => {
			setLoading(true);
			try {
				const response = await getPowerBIContent(user.clientId);
				setReportData(response.result);
			} catch (error) {
				console.error("Error fetching report data: ", error);
			} finally {
				setLoading(false);
			}
		};

		getReportData();
	}, []);

	return (
		<Box>
			{Boolean(loading) ? (
				<Box>
					<LinearProgress />
				</Box>
			) : (
				<>
					{reportData && (
						<PowerBIEmbed
							embedConfig={{
								type: "report",
								id: reportData.embedReport?.[0].reportId,
								embedUrl: reportData.embedReport?.[0].embedUrl,
								accessToken: reportData.embedToken.token,
								tokenType: models.TokenType.Embed,
								settings: {
									panes: {
										filters: {
											expanded: true,
											visible: false,
										},
										pageNavigation: {
											visible: false,
										},
									},
									background: models.BackgroundType.Transparent,
								},
							}}
							eventHandlers={
								new Map([
									[
										"loaded",
										function () {
											console.log("Report loaded");
										},
									],
									[
										"rendered",
										function () {
											console.log("Report rendered");
										},
									],
									[
										"error",
										function (event) {
											console.log(event.detail);
										},
									],
								])
							}
							cssClassName={"report-style-class"}
						/>
					)}
				</>
			)}
		</Box>
	);
};

export default PowerBiReport;
